// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 134) return "static/chunks/134-9bf655411311518a.js";
	if (chunkId === 352) return "static/chunks/352-df4396c30a855d02.js";
	if (chunkId === 874) return "static/chunks/874-735ed44fd6e8175b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"393":"dba864930c0ed405","449":"ce4dea6c59a5304a","610":"bda6a163e420bab1","710":"69dbb77a81848564","718":"7315a89794699640"}[chunkId] + ".js";
};